import i18n from '@/locale';
import common from '../component/common';
import chartOptions from '../chart/chart_options';
import request from '../utils';
import helper from '../helper';

const getSensorBoXDailyChartOpt = (formdata, measureList) => new Promise((resolve) => {
  const url = '/panel/sensorbox/list';

  const tempData = request.Api(url, formdata, 'post');
  tempData.then((_rawData) => {
    if (_rawData.status !== 200) {
      resolve({});
      return;
    }
    if (_rawData.data.success === 'false') {
      resolve({});
      return;
    }
    const sortType = 'Hour';

    const res = _rawData.data.data.sort((a, b) => {
      if (a[sortType] < b[sortType]) return -1;
      if (a[sortType] > b[sortType]) return 1;
      return 0;
    });

    const timeField = [];
    const yAxis = [];
    const max_val = {};
    const tempTimeData = {};
    let colorKey = 0;
    let offset = 0;
    let total_Val = 0;
    const series = [];
    const measures = ['Irr', 'Temp'];
    const colors = ['#5470C6', '#91CC75', '#EE6666'];

    res.forEach((item) => {
      let hh;
      let mm;
      item.Hour < 10 ? hh = `0${item.Hour}` : hh = `${item.Hour}`;
      item.MinuteGrup < 10 ? mm = `0${item.MinuteGrup}` : mm = `${item.MinuteGrup}`;
      const date = `${hh}:${mm}`;

      if (!tempTimeData[item.SENSOR]) {
        tempTimeData[item.SENSOR] = {};
      }
      tempTimeData[item.SENSOR][date] = item;

      Object.keys(measureList).forEach((k) => {
        const tmp1 = parseInt(item[measureList[k].value]);
        if (!max_val[measureList[k].value]) {
          max_val[measureList[k].value] = 0;
        }

        if (tmp1 > max_val[measureList[k].value]) { max_val[measureList[k].value] = tmp1; }
      });
    });

    const measure_key = ['Irr', 'Temp'];

    const color = common.colors();
    const step_time = helper.getSantralStep(formdata.condiniton.santral);

    Object.keys(measureList).forEach((k) => {
      measure_key.forEach((k1) => {
        const tempData = [];
        const minute = 0;
        const hour = 5;

        for (let i = hour; i <= 20; i++) {
          for (let x = minute; x < 60; x += step_time) {
            let h; let
              m;
            i < 10 ? h = `0${i}` : h = `${i}`;
            x < 10 ? m = `0${x}` : m = `${x}`;
            const time = `${h}:${m}`;

            if (colorKey == 0) {
              timeField.push(time);
            }

            let vals = 0;

            if (tempTimeData.hasOwnProperty(k)) {
              if (tempTimeData[k].hasOwnProperty(time)) {
                if (tempTimeData[k][time].hasOwnProperty(measureList[k][k1]
                  .value)) {
                  vals = tempTimeData[k][time][measureList[k][k1].value];
                }
              }
            }

            if (total_Val < parseFloat(vals)) {
              total_Val = parseFloat(vals);
            }

            tempData.push(Math.round(vals, 1));
          }
        }

        const chartType = 'line';

        const obj = {
          name: `${k} ${i18n.t(measureList[k][k1].text)}(${
            measureList[k][k1].unit})`,
          data: tempData,
          type: chartType,
        };

        let position = 'left';
        if (colorKey > 0) {
          position = 'right';
          obj.yAxisIndex = colorKey;
        }

        if (colorKey > 1) {
          offset += 110;
        }

        total_Val = max_val[measureList[k][k1].value] * 120 / 100;

        const x_Axis = {
          type: 'value',
          name: `${i18n.t(measureList[k][k1].value)}(${
            measureList[k][k1].unit})`,
          min: 0,
          max: total_Val,
          offset,
          position,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[colorKey],
            },
          },
          axisLabel: {
            formatter: `{value} ${measureList[k][k1].unit}`,
          },
        };
        if (colorKey > 1) {
          x_Axis.show = false;
        }

        yAxis.push(x_Axis);
        series.push(obj);
        colorKey += 1;
      });
    });

    const options = chartOptions.multi_line_option(timeField, measures, series, color,
      yAxis);

    resolve(options);
  });
});

export default {
  getSensorBoXDailyChartOpt,
};
